const textfield = {
  variants: [
    {
      props: { size: 'small' },
      style: ({ theme }) => ({
        '& .MuiInputBase-root': {
          fontSize: '0.875rem',
          borderRadius: theme.shape.borderRadius,          
          border: 1,
          borderColor: theme.palette.neutral[200]          
        },
        '& label': {
          fontSize: '0.875rem',
          color: theme.palette.text.secondary,
        },
        '& .MuiInputBase-root:hover': {
          border: 1,
          borderColor: theme.palette.primary.main,
        },
      }),
    },
    {
      props: { size: 'medium' },
      style: ({ theme }) => ({
        '& .MuiInputBase-root': {
          fontSize: '1rem',
          borderRadius: theme.shape.borderRadius,
          border: 1,
          borderColor: theme.palette.neutral[200]
        },
        '& label': {
          fontSize: '1rem',
          color: theme.palette.text.secondary,
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.primary.main,
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.primary.main,
        },     
      }),
    },
  ],
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
    }),
  },
};

export default textfield;